/* eslint-disable react/no-unescaped-entities */
import EmptyState from '@/components/molecules/EmptyState';
import Head from 'next/head';

export default function FiveHundred(): JSX.Element {
	return (
		<>
			<Head>
				<title>Something went wrong</title>
			</Head>
			<EmptyState
				img="/500.png"
				primaryText="Something went wrong!"
				secondaryText="Give us a moment while we fix this. In the meantime, check out where others have been!"
				ctaLabel="EXPLORE DESTINATIONS"
				link="/"
			/>
		</>
	);
}
